import React from 'react';
import Header from '@ui/Header';
import BackgroundView from '@ui/BackgroundView';

export default function Dashboard() {
  return (
    <BackgroundView>
      <Header titleText="Give Dashboard" />
    </BackgroundView>
  );
}



// WEBPACK FOOTER //
// ./src/give/ThankYou.js